// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"j5-z","colorTextValue":"k5-z","swatches":"l5-z","collapseLink":"m5-z","isCollapsed":"n5-z","dropdown":"o5-z","disabled":"p5-z"};